/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

// For vendors for example jQuery, Lodash, angular2-jwt just import them here unless you plan on
// chunking vendors files for async loading. You would need to import the async loaded vendors
// at the entry point of the async loaded file. Also see custom-typings.d.ts as you also need to
// run `typings install x` where `x` is your module

// Angular
// import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/platform-browser/animations';
import '@angular/core';
import '@angular/common';
import '@angular/common/http';
import '@angular/compiler';
import '@angular/forms';
import '@angular/router';
import '@ngx-translate/core';
import '@ngx-translate/http-loader';
import 'ngx-bootstrap';
import 'class-transformer';
import 'raven-js';
import 'moment';
import 'lodash';
import 'angular2-moment';
import '@angularclass/hmr';

// AngularClass
// import '@angularclass/hmr';

// RxJS
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';

if ('production' === process.env.ENV) {
    // Production


} else {
    // Development

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/vendor.ts